/* eslint-disable class-methods-use-this */
import Popup from './popup';

export default class LinkPopup extends Popup {
  createComponent() {
    return document.createElement(`au-${this.type}`);
  }

  setAttributes(linkPopup, linkDeleteDetails) {
    linkPopup.setAttribute('name', linkPopup._link.name);

    linkPopup.setAttribute('view', linkDeleteDetails.view);

    linkPopup.setAttribute('main-content', linkDeleteDetails.mainContent);

    linkPopup.setAttribute('semantic-name', linkPopup._link.semanticName);
  }
}
